
    import {Component, Prop, Vue} from 'vue-property-decorator';
    import {inspectionOrderApi} from "@/api/inspection";
    import baseUrl, {imageUrl} from "@/constants";
    import {rulesApi} from "@/api/rules";
    import {dictApi, dictInstrumentApi, mechanismApi} from "@/api/organization";
    import {instrumentApi} from "@/api/instrument";
    import ckeditor4 from "@/components/CkeditorComponent.vue";
    const {CodeToText, regionData} =require("@/js/region/region");

    @Component({
        name: "AddExamine",
        components: {ckeditor4}
    })
    export default class AddExamine extends Vue {
        title = "添加、编辑检定结果";
        addExamineDialog = true;
        form = null as any;
        rules = {
            certificateType: [{ required: true, message: '请选择检定/校准类型', trigger: 'change' }],
            certificationNumber: [{ required: true, message: '请输入证书编号', trigger: 'blur' }],
            checkPersonName: [{ required: true, message: '请输入校准员姓名', trigger: 'blur' }],
            checkCocn: [{ required: true, message: '请输入结论', trigger: 'blur' }],
            reApproverName: [{ required: true, message: '请输入核验员姓名', trigger: 'blur' }],
            inspectionDate: [{ required: true, message: '请输入校准日期', trigger: 'blur' }],
            approverName: [{ required: true, message: '请输入批准人姓名', trigger: 'blur' }],
            expireDate: [{ required: true, message: '请输入有效期', trigger: 'blur' }],
            enclosure: [{ required: true, message: '请上传检定结果复印件', trigger: 'change' }],
            issueDate: [{ required: true, message: '请输入签发日期', trigger: 'blur' }],
            technicalDepartName: [{required: true, message: '请输入机构名称', trigger: 'blur'}],
            resultText: [{ required: true, message: '请输入', trigger: 'blur' }],
        }
        fileListCheck = [] as any;
        baseUrl = baseUrl;
        imageUrl = imageUrl;
        headers = {Authorization:""}
        showOnlyForm = null as any;
        typeCodeList = [];
        purposeCodeList = [];
        listInstrument = [] as any //器具备选列表
        props = {
            value: 'instrumentNameId',
            label: 'name',
        }
        regionData = regionData;
        basedRuleName = ""; //规程规范名称
        stopReason = {
            visible: false,
            resultText: "",
        }
        /**
         * 编辑的id
         * */
        @Prop() private id!: any;
        // 2 为仅展示
        @Prop() private showType!: any;
        // 是否是特殊添加检定档案模式，特殊需要传orderInstrumentsId
        @Prop() private specialAddExamine!: any;
        // 外部器具参数
        @Prop() private externalData!: any;
        // 编辑参数
        @Prop() private editData!: any;

        created() {
            this.getDict(1);
            this.getDict(2);
            this.getListInstrument();
            this.getInstrmentDetail();
            this.form = this.getForm();
            if(this.editData.certificateType){
                this.form = this.editData;
                if(this.form.enclosure){
                    this.fileListCheck = [];
                    try {
                        var obj=JSON.parse(this.form.enclosure);
                        if(typeof obj == 'object' && obj ){
                            for(let i = 0; i < obj.length; i++){
                                this.fileListCheck.push({name: obj[i].name ,url: imageUrl+obj[i].url})
                            }
                        }
                    } catch(e) {
                        const arr = this.form.enclosure.split(",");
                        for(let i = 0; i < arr.length; i++){
                            this.fileListCheck.push({name:"证书文件",url: imageUrl+arr[i]})
                        }
                    }
                }
            }
        }
        changeCheckCocn(){
            if(this.form.checkCocn.indexOf("不合格") > -1){
                this.form.expireDate = "——";
            }
        }

        // 点击不详按钮
        buxiang(formKey: string) {
            let str = '';
            if (this.form[formKey] === '——') {
                str = '';
            } else {
                str = '——';
            }
            this.$set(this.form, formKey, str);
        }

        querySearch(queryString: string, cb: any) {
            if(queryString.length < 2){
                cb([]);
                return;
            }
            mechanismApi.listMechanismV2({organizationType: ['0001', '0006' ,'0003' , '0008'].join(","), name: queryString}).then((r: any) => {
                if(r.data.result === 0){
                    // 调用 callback 返回建议列表的数据
                    cb(r.data.data);
                }
            });
        }

        getDict(category: number, code: string | string = ""){
            return dictApi.list({
                category: category,
                code: code
            }).then(r=>{
                if(r.data.result === 0){
                    const rData = r.data.data;
                    if(category == 1){
                        this.typeCodeList = rData;
                    }else if(category == 2){
                        this.purposeCodeList = rData;
                    }
                }
            })
        }
        initFormData(certType: string){
            const cenrTypes = ['1', '2', '5'];
            if(cenrTypes.indexOf(certType) > -1){
                let receiptDate = "";
                let technicalDepartName = "";
                if(this.externalData){
                    receiptDate = this.externalData.submitDate;
                    technicalDepartName = this.externalData.technicalDepartName;
                }
                return {
                    certificateType: certType,   //证书类型
                    certificationNumber: "",   //证书编号
                    basedRuleName: this.basedRuleName,   //检定依据名称
                    checkPersonName: "",   //检定员姓名/校准员姓名
                    checkCocn: "",   //检定结论
                    technicalDepartName: technicalDepartName, //检定机构
                    reApproverName: "",   //核验员
                    inspectionDate: "",   //检定日期/校准日期
                    approverName: "",   //批准人
                    expireDate: "",   //有效期至
                    enclosure: "",   //影印件
                    receiptDate: receiptDate,  //接收日期
                    issueDate: "",  //签发日期
                    resultText: "", //结果Text
                } as any
            }else{
                return {
                    certificateType: certType,   //证书类型
                    technicalDepartName: "——", //检定机构
                    certificationNumber: "——",   //证书编号
                    basedRuleName: "——",   //检定依据名称
                    checkPersonName: "——",   //检定员姓名/校准员姓名
                    checkCocn: "——",   //检定结论
                    reApproverName: "——",   //核验员
                    inspectionDate: "",   //检定日期/校准日期
                    approverName: "——",   //批准人
                    expireDate: "",   //有效期至
                    enclosure: "",   //影印件
                    receiptDate: "",  //接收日期
                    issueDate: "",  //签发日期
                    resultText: "", //结果Text
                } as any
            }
        }
        onChangeCertType(){
            this.form = this.initFormData(this.form.certificateType);
        }
        //获取器具备选列表个
        getListInstrument(){
            return dictApi.listDictInstrument().then(r=>{
                if (r.data.result === 0) {
                    const rData = r.data.data;
                    this.porjectTree(rData);
                    this.listInstrument = rData;
                }
            })
        }
        porjectTree(projectList: any){
            projectList.forEach((project: any) => {
                if(project.children.length > 0){
                    this.porjectTree(project.children);
                }else{
                    project.children = null;
                }
            })
        }
        getInstrmentDetail(){
            instrumentApi.getDetailById({id:this.id}).then(r=>{
                if (r.data.result === 0) {
                    const rData = r.data.data;
                    this.getInstrumentDict(rData);
                    this.showOnlyForm = rData;
                    this.showOnlyForm.useAddrCodeArr = rData.useAddrCode ? rData.useAddrCode.split(",") : [];
                    this.$nextTick(()=>{
                        const arr = [];
                        arr.push(Number(rData.majorCode));
                        arr.push(Number(rData.classCode));
                        arr.push(Number(rData.categoryCode));
                        arr.push(Number(rData.instrumentNameId));
                        this.showOnlyForm.name = arr;
                    })
                }
            })
        }
        getInstrumentDict(data: any){
            dictInstrumentApi.getOne({id:data.dictInstrumentId}).then(r=> {
                if (r.data.result === 0) {
                    const rData = r.data.data;
                    this.basedRuleName = rData.rules;
                }
            })
        }
        //终止
        onStop(){
            this.stopReason.visible = true;
        }
        formCheck(checkResult: number, callback: any){
            if(checkResult === 12){
                let form = this.$refs.stopReasonForm as HTMLFormElement;
                form.validate((valid:any) => {
                    if(valid){
                        callback();
                    }
                });
            }else{
                //影印件****
                const enclosureList = this.fileListCheck.map((e:any)=> e.url.replace(imageUrl,""));
                this.form.enclosure = enclosureList.length === 0 ? "" :  enclosureList.join(",");
                //影印件end****
                let form = this.$refs.form as HTMLFormElement;
                form.validate((valid:any) => {
                    if(valid){
                        callback();
                    }
                });
            }
        }
        //保存检定证书/结果
        onSubmit(checkResult: number) {
            this.formCheck(checkResult,() => {
                let params: any = {...this.form};
                if(checkResult === 12) {
                    Object.assign(params, {
                        certificateType: "——",//证书类型
                        certificationNumber: "——",   //证书编号
                        basedRuleName: "——",   //检定依据名称
                        checkPersonName: "——",   //检定员姓名/校准员姓名
                        checkCocn: "——",   //检定结论
                        reApproverName: "——",   //核验员
                        inspectionDate: "",   //检定日期/校准日期
                        approverName: "——",   //批准人
                        expireDate: "",   //有效期至
                        technicalDepartName: "——",
                        receiptDate: "",  //接收日期
                        issueDate: "",  //签发日期
                        resultText: this.stopReason.resultText
                    });
                }
                //如果未通过  则只存结果
                if(this.specialAddExamine){
                    params = Object.assign(params, {orderInstrumentsId: this.editData.id,submitForm: 1, checkResult: checkResult});
                }else{
                    params = Object.assign(params, {instrumentsId: this.id, submitForm: 0, checkResult: checkResult});
                }
                inspectionOrderApi.updateInspectionOrderInstruments(params).then(r=>{
                    if(r.data.result === 0){
                        this.$message.success("保存成功");
                        this.clostDialog();
                    }
                })
            });
        }
        getForm(){
            return {
                technicalDepartName: "", //检定机构名称
                certificationNumber: "",   //证书编号
                certificateType: "",       //证书类型
                inspectionDate: "",        //检定日期
                expireDate: "",            //有效期
                checkCocn: "",             //检定结论
                checkResult: 1,           //检定状态
                resultText: "",                //检定结果
                basedRuleId: "",           //检定依据
                basedRuleName: "",         //检定依据名称
                reason: "",                //不合格原因
                checkPersonId: "",         //检定员id
                checkPersonName: "",       //检定员姓名
                checkPersonCardCode: "",   //检定员身份证号
                reApproverId: "",          //核验员id
                reApproverName: "",        //核验员姓名
                reApproverCardCode: "",    //核验员身份证号
                approverId: "",            //批准人id
                approverName: "",          //批准人名称
                approverCardCode: "",      //批准人身份证号
            }
        }
        //上传检定结果复印件
        //上传监控
        handleAvatarSuccessCheck(res: any, file: any) {
            if (res.result === 0) {
                const rData = res.data;
                this.fileListCheck.push({name: "检定结果.pdf",url: imageUrl+rData})
            }
        }
        handleRemoveCheck(file: any, fileList: any) {
            const index = this.fileListCheck.findIndex((e: any) => e.url === file.url);
            if (index > -1) {
                this.fileListCheck.splice(index, 1);
            }
        }
        handlePictureCardPreviewCheck(file: any) {
            const fix = this.filesuffix(file.url);
            if(fix == "pdf"){
                window.open(baseUrl + "/file/download?file=" + file.url.replace(imageUrl,"") + "&name=" + file.name, '_blank');
            }
        }
        filesuffix(fileName: string) {
            const first = fileName.lastIndexOf(".");//取到文件名开始到最后一个点的长度
            const namelength = fileName.length;//取到文件名长度
            const filesuffix = fileName.substring(first + 1, namelength);//截取获得后缀名
            return filesuffix;
        }
        //上传监控
        beforeAvatarUploadCheck(file: any) {
            const isPDF = file.type === 'application/pdf';
            if (!isPDF) {
                this.$message.error('上传图片只能是PDF格式!');
            }
            return (isPDF);
        }

        clostDialog() {
            this.$emit("clostDialog")
        }
    }
